(() => {
  'use strict';

  const configured = Number.parseInt(window.NUT_MAX_ORDER_QUANTITY, 10);
  const LIMIT = Number.isFinite(configured) && configured > 0 ? configured : 6;
  const INPUT_SELECTOR = [
    'hdt-cart-drawer input[name="updates[]"]',
    '.hdt-mini-cart input[name="updates[]"]',
    '#MainContent input[name="updates[]"]',
    'cart-items-component input[name="updates[]"]'
  ].join(',');

  const numberValue = (value, fallback = 1) => {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const plusButtonFor = (input) =>
    input.closest('.hdt-quantity-cart-item, [data-quantity-wrapper], hdt-quantity-wrapp')?.querySelector('button[name="plus"], button.is--plus');

  const syncButton = (input) => {
    const plus = plusButtonFor(input);
    if (!plus) return;
    const atLimit = numberValue(input.value) >= LIMIT;
    plus.disabled = atLimit;
    plus.setAttribute('aria-disabled', atLimit ? 'true' : 'false');
    plus.classList.toggle('disabled', atLimit);
  };

  const syncInput = (input, { updateCart = false } = {}) => {
    if (!(input instanceof HTMLInputElement)) return;

    input.max = String(LIMIT);
    input.dataset.max = String(LIMIT);
    input.dataset.nutThemeMax = String(LIMIT);

    const min = Math.max(1, numberValue(input.min, 1));
    const current = numberValue(input.value, min);
    const clamped = Math.min(LIMIT, Math.max(min, current));

    if (current !== clamped) {
      input.value = String(clamped);
      if (updateCart && input.dataset.nutClampDispatched !== 'true') {
        input.dataset.nutClampDispatched = 'true';
        queueMicrotask(() => {
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    }

    syncButton(input);
  };

  const scan = (scope = document, updateExisting = false) => {
    if (scope instanceof Element && scope.matches(INPUT_SELECTOR)) {
      syncInput(scope, { updateCart: updateExisting });
    }
    scope.querySelectorAll?.(INPUT_SELECTOR).forEach((input) => {
      syncInput(input, { updateCart: updateExisting });
    });
  };

  document.addEventListener('click', (event) => {
    const plus = event.target.closest?.('button[name="plus"], button.is--plus');
    if (!plus) return;
    const wrapper = plus.closest('.hdt-quantity-cart-item, [data-quantity-wrapper], hdt-quantity-wrapp');
    const input = wrapper?.querySelector('input[name="updates[]"]');
    if (!input) return;

    syncInput(input);
    if (numberValue(input.value) >= LIMIT) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('input', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches(INPUT_SELECTOR)) return;
    const current = numberValue(input.value, 1);
    if (current > LIMIT) input.value = String(LIMIT);
    syncButton(input);
  }, true);

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches(INPUT_SELECTOR)) return;
    syncInput(input);
  }, true);

  const initialScan = () => scan(document, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialScan, { once: true });
  } else {
    initialScan();
  }

  ['cart:update', 'shopify:section:load', 'cart:refresh'].forEach((eventName) => {
    document.addEventListener(eventName, () => setTimeout(() => scan(document, true), 0));
  });

  const observer = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.('hdt-cart-drawer, .hdt-mini-cart, cart-items-component, .hdt-cart-item') || node.querySelector?.(INPUT_SELECTOR)) {
          scan(node, true);
        }
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
